export default {
  ADD_LOCATION: "ADD_LOCATION",
  SEARCH: "SEARCH",
};
